module.exports = __webpack_public_path__ + "static/media/zcdt_Down.e8e73a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zcdt_Down.png
// module id = 1879
// module chunks = 0 1